export const cmvReportV2 = {
	label: "CMV",
	description:
		"O CMV (Custo de Mercadorias Vendidas) é um indicador financeiro que representa os custos diretos.",
	states: {
		empty: {
			title: "Nenhum dado de CMV encontrado",
			description: "Não há informações de CMV para o período selecionado.",
		},
		error: {
			title: "Não foi possível carregar o CMV",
			description:
				"Ocorreu um erro ao carregar o relatório de CMV. Tente novamente em instantes.",
		},
	},
	kpis: {
		itemsSold: "Itens vendidos",
		grossRevenue: "Faturamento bruto",
		totalCost: "Custo total",
		marginCmv: "Margem CMV",
		cmvPercent: "CMV em porcentagem",
	},
	header: {
		periodPlaceholder: "Selecione o período",
		export: "Exportar Excel",
		type: {
			all: "Todos os produtos",
			fromPlace: "Produtos do place",
			fromVendor: "Produtos do fornecedor",
		},
	},
	filters: {
		searchPlaceholder: "Buscar por produto ou SKU",
		categoriesPlaceholder: "Todas as categorias",
		viewBy: {
			byCategory: "Visualizar por categorias",
			byProduct: "Visualizar por produtos",
		},
	},
	chart: {
		title: "Faturamento vs CMV por categorias",
		legend: {
			revenue: "Faturamento",
			cmv: "CMV",
		},
		tooltip: {
			revenue: "Faturamento",
			cmv: "CMV",
		},
		empty: {
			title: "Sem dados para o gráfico",
			description: "Nenhuma categoria com vendas no período e filtros selecionados.",
		},
	},
	table: {
		columns: {
			category: "CATEGORIA",
			soldQty: "QTD VENDIDA",
			grossRevenue: "FATURAMENTO BRUTO",
			totalCost: "CUSTO TOTAL",
			costPercent: "CUSTO PERCENTUAL",
			cmv: "CMV",
			margin: "MARGEM",
			product: "Produto",
			sku: "SKU",
			productSoldQty: "QTD vendida",
			losses: "Perdas",
			unitValue: "Valor unit.",
			unitCost: "Custo Unit.",
			productTotalValue: "Valor total",
			productTotalCost: "Custo total",
			productMargin: "Margem",
			productCmv: "CMV",
		},
		empty: {
			title: "Nenhum produto encontrado",
			description: "Não há produtos para os filtros selecionados.",
		},
	},
	zeroedCost: {
		card: {
			label: "Produtos com custo zerado",
			alert: {
				title: "Melhore seu CMV",
				description: "Ajuste os custos dos produtos.",
				cta: "Ajustar produtos",
			},
			success: {
				title: "CMV sem inconsistências",
				description: "Todos os produtos estão com os custos atualizados",
			},
		},
		drawer: {
			title: "Produtos com custo zerado",
			back: "Voltar",
			cancel: "Cancelar",
			submit: "Atualizar produtos",
			success: "Custos atualizados com sucesso",
			loading: "Carregando produtos...",
			choice: {
				title: "Como você deseja atualizar os custos dos produtos zerados?",
				manual: {
					title: "Manualmente",
					description:
						"Você visualiza todos os produtos zerados e atualiza os custos sem sair do dashboard.",
				},
				xlsx: {
					title: "Em massa via planilha Excel",
					description:
						"Disponibilizamos uma planilha com todos os produtos zerados, você preenche com os custos e faz o upload aqui.",
				},
			},
			manual: {
				subtitle: "Atualizar custos zerados manualmente",
				empty: "Nenhum produto com custo zerado.",
				error: "Não foi possível carregar os produtos.",
				columns: {
					product: "Produto",
					sku: "SKU",
					storage: "Estoque",
					lastCost: "Último custo",
					unitCost: "Custo unitário",
				},
			},
			xlsx: {
				placeholder: "Importação via planilha em breve.",
			},
		},
	},
};
